import triggerConfig from '../config/triggerConfig.mjs';
import buildGA4Event from './buildGA4Event.mjs';
export default function (trigger) {
    const config = triggerConfig[trigger.name];
    if (!config) {
        throw new Error('GA4 event trigger does not exist');
    }
    return buildGA4Event({ trigger, config });
}
